import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import ListItemText from '@material-ui/core/ListItemText';
import SarasPopup from '../../container/popup/SarasPopup';
import SarasTrans from '../../notifications/SarasTrans';
import { Icon } from '../../decor/SarasIcons';

const SarasMenu = (props) => {
  const { menuContainerClass, menuTrigger, contentStyle, dataList, menuListClass,
    disableToHide, dynamicTriigerAnchorRef, isDynamicTrigger, onClose,
    onShouldHideOption, menuItem: ChildMenuItem, onSelection, hideTriggerIfNoOptions,
    minimumOptionsToDisplayTrigger, 
    selectionIcon = 'defaultTick', 
    initialSelectedIndex, trackSelection = false } = props;

  const [open, setOpen] = React.useState(isDynamicTrigger || false);
  const [selectedIndex, setSelectedIndex] = React.useState(
    initialSelectedIndex !== undefined && initialSelectedIndex !== null
      ? Number(initialSelectedIndex)
      : null
  );

  const anchorRef = React.useRef(null);

  const disable = disableToHide ? !dataList || dataList.length === 0 : false;

  // keep in sync if parent changes initialSelectedIndex later
  React.useEffect(() => {
    if (initialSelectedIndex !== undefined && initialSelectedIndex !== null) {
      setSelectedIndex(Number(initialSelectedIndex));
    }
  }, [initialSelectedIndex]);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const shouldHide = (row) => {
    if(onShouldHideOption) return onShouldHideOption(null, row);

    return false;
  }

  const handleSelection = (event, index) => {
      setSelectedIndex(index);
      if(onSelection) onSelection(event, String(index));
      setOpen(false);
  };

  const onChildAction = (event, index) => {
    if(onSelection) onSelection(event, String(index));
    setOpen(false);
  }

  const handleClose = (event) => {
    setOpen(false);
    if(onClose) onClose(event);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }

  const renderMenuTrigger = () => {
    // console.log("render trigger", menuTrigger);
    if(menuTrigger != null) {
      return menuTrigger;
    }
    else {
      return <span><SarasTrans value = "Menu"/></span>
    }
  }

  //do not execute these logic if menu is to be disabled
  if(!disable) {
    if((!dataList || dataList.length === 0) && hideTriggerIfNoOptions === 1)
    {
      return null;
    }

    if((!dataList || dataList.length < minimumOptionsToDisplayTrigger) 
      && minimumOptionsToDisplayTrigger > 0  && hideTriggerIfNoOptions === 1)
    {
      return null;
    }
  }

  // selectedIndex && console.log("SarasMenu initialSelectedIndex changed", dataList, selectedIndex);
  const TickIcon = Icon[selectionIcon || 'defaultTick'];

    return (
      <>
        {!isDynamicTrigger && <span className={menuContainerClass || ''}>
          <span
            ref={anchorRef}
            aria-controls={open ? 'menu-list-grow' : undefined}
            aria-haspopup="true"
            onClick={disable ? undefined : handleToggle}
          >
            {renderMenuTrigger()}
          </span>
        </span>
        }
        <SarasPopup anchorRef={dynamicTriigerAnchorRef || anchorRef} open={open} onClose={handleClose}>
            <MenuList style={contentStyle} autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}
              className={menuListClass || ''} >
              {dataList.map((row, index)=>(
                  shouldHide(row) ? null : 
                  <MenuItem key={index} 
                    onClick={(event) => handleSelection(event, index)}
                    rowkey={index}>
                    {trackSelection && <TickIcon
                      fontSize="small"
                      className={`uiMenuSelectedIcon ${
                        selectedIndex === index ? 'uiMenuSelectedIcon--visible' : 'uiMenuSelectedIcon--hidden'
                      }`}
                    />}
                    <ListItemText>
                      <ChildMenuItem viewData={row} index={index} onChildAction={onChildAction}>
                      </ChildMenuItem>
                    </ListItemText>
                  </MenuItem>
              ))}
            </MenuList>
        </SarasPopup>
      </>
  );
}

export default SarasMenu;